// Import-free on purpose: the client-report renderers also run it in the Functions host.

/**
 * Makes text safe to place in HTML element content or in a quoted attribute
 * value (either quote). It does not make a URL safe to use as one.
 */
export function escapeHtml(value: unknown): string {
    if (value === null || value === undefined) return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
